// extracted by mini-css-extract-plugin
export default {"pageWrapper":"LeaderboardPage-module__pageWrapper--JDVkM","tabs":"LeaderboardPage-module__tabs--H8aYB","leaderboardPlug":"LeaderboardPage-module__leaderboardPlug--TuRpc"};